// Coming soon mode: email signup popup that opens on arrival and replaces
// every add to cart while the store can't sell yet.
class DuneComingSoon extends HTMLElement {
  static cookieName = 'dune-coming-soon';

  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    const formState = this.dataset.formState;

    if (formState === 'success') this.setCookie('subscribed', 365);
    this.dataset.state = this.getCookie() === 'subscribed' ? 'success' : 'form';

    this.querySelectorAll('[data-dune-cs-close]').forEach((button) =>
      button.addEventListener('click', () => this.dialog.close())
    );
    // A click on the backdrop lands on the dialog element itself
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
    this.dialog.addEventListener('close', () => {
      if (this.getCookie() !== 'subscribed') this.setCookie('dismissed', Number(this.dataset.expiry));
    });

    // Add to cart is blocked by snippets/dune-coming-soon-guard.liquid, which asks for the popup
    document.addEventListener('dune:coming-soon-open', this.open);

    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) this.open();
      });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) this.dialog.close();
      });
      return;
    }

    if (formState || window.duneComingSoonRequested) {
      this.open();
    } else if (!this.getCookie()) {
      // Skip if the visitor already opened and closed it from an add to cart
      setTimeout(() => !this.getCookie() && this.open(), Number(this.dataset.delay) * 1000);
    }
  }

  disconnectedCallback() {
    document.removeEventListener('dune:coming-soon-open', this.open);
  }

  open = () => {
    if (this.dialog.open) return;
    this.dialog.showModal();
    // Focus the dialog rather than its first button, so no focus ring shows on open
    this.dialog.focus();
  };

  getCookie() {
    const match = document.cookie.match(`(?:^|;)\\s*${DuneComingSoon.cookieName}=([^;]+)`);
    return match ? match[1] : null;
  }

  setCookie(value, days) {
    document.cookie = `${DuneComingSoon.cookieName}=${value}; max-age=${days * 24 * 60 * 60}; path=/; SameSite=Lax`;
  }
}

customElements.define('dune-coming-soon', DuneComingSoon);
